// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationBanner-cls1___817bee68aec755be0c1{/*!*/}.ConfirmationBanner-cls2___2a3b807c5a0cfaf50fc{color:#fff;cursor:pointer;text-decoration:underline}.ConfirmationBanner-cls2___2a3b807c5a0cfaf50fc:not(:last-of-type){margin-right:10px}.ConfirmationBanner-cls2___2a3b807c5a0cfaf50fc:hover{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationBanner-cls1___817bee68aec755be0c1",
	"cls2": "ConfirmationBanner-cls2___2a3b807c5a0cfaf50fc ConfirmationBanner-cls1___817bee68aec755be0c1"
};
export default ___CSS_LOADER_EXPORT___;
